import React from 'react';

import './animatedDotsComponent.css';

const AnimatedDotsComponent = ({isMentor = false}) => {
  return (
    <div
      className={`et-v2-animated-dots-container ${isMentor ? 'et-v2-animated-dots-container-mentor' : ''}`}>
      <i className="et-v2-adc-dot fas fa-circle" />
      <i className="et-v2-adc-dot fas fa-circle" />
      <i className="et-v2-adc-dot fas fa-circle" />
    </div>
  );
};

export default AnimatedDotsComponent;
